import { Spin } from 'antd'
import { Suspense, lazy } from 'react'
import { TbLayoutKanban } from 'react-icons/tb'

import { APPLICATION_STATUS_RESOURCE } from '../Contracts/IApplication'
import { applicationKanbanRows } from './applicationKanbanRows'

import type { TransportRequestKanbanProps } from '@/Containers/TransportationSection/Components'

const TransportRequestKanban = lazy(() => import('@/Containers/TransportationSection/Components/TransportRequestKanban'))

type KanbanProps = Omit<TransportRequestKanbanProps, 'statusResource' | 'rows'>

/** Мінімум headerPage-контексту, потрібний реєстрації режиму «Канбан». */
interface HeaderPageContextLike {
    storages?: {
        crudContext?: {
            listContext?: { variantItems?: Record<string, unknown> }
            resource?: unknown
        } & Record<string, unknown>
    }
}

/**
 * Канбан заявок — адаптер спільного канбану секції над Ship `Kanban readOnly`
 * (`SPEC-021` §8.3, Q2.9): колонки — статуси довідника, на «Рейсах» — лише 6
 * статусів префільтра; без перетягування (ДП-10).
 */
const ApplicationKanbanTemplate = (props: KanbanProps) => (
    <Suspense
        fallback={
            <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
                <Spin />
            </div>
        }
    >
        <TransportRequestKanban {...props} statusResource={APPLICATION_STATUS_RESOURCE} rows={applicationKanbanRows} />
    </Suspense>
)

/**
 * Обробник `headerPage.eventHandlers.onAfterInit`: дописує режим «Канбан» у
 * `variantItems` поряд із ядровою таблицею, перемикач малює ядро (той самий
 * шлях, що в запиту й тендера).
 */
export const addApplicationKanbanMode =
    (extra: Pick<KanbanProps, 'statusCodes' | 'hideOffers'> = {}) =>
    ({ headerPageContext }: { headerPageContext?: HeaderPageContextLike }): void => {
        const crudContext = headerPageContext?.storages?.crudContext
        const listContext = crudContext?.listContext

        if (!crudContext || !listContext) return

        listContext.variantItems = {
            ...(listContext.variantItems ?? {}),
            kanban: {
                label: 'Канбан',
                icon: TbLayoutKanban,
                template: ApplicationKanbanTemplate,
                props: { crudContext, ...extra },
            },
        }
    }
